// Optional equipment an office can declare for a vehicle. Keys are stored on
// the RentalCar document; labels come from `carProfile.featureOptions.*` in the
// locale files. Keep this list in sync with `vehicleFeatureKeys` in the API
// (backend-api/api/src/common/constants.js) and with the storefront copy.
export const VEHICLE_FEATURE_KEYS = [
  'powerWindows',
  'leatherSeats',
  'airConditioning',
  'auxUsbPort',
  'alarmSystem',
  'electricSeatControl',
  'rearParkingSensors',
  'keylessEntry',
  'sunroof',
  'bluetooth',
  'forwardCollisionWarning',
  'radar',
  'touchScreen',
  'cruiseControl',
  'remoteStart',
  'tractionControl',
  'rearCamera',
  'camera360',
  'automaticDoorLock',
  'parkingAssist',
]

export const defaultVehicleFeatures = VEHICLE_FEATURE_KEYS.reduce((acc, key) => ({ ...acc, [key]: false }), {})
